/**
 * 헤더 내비 로딩 시 레이아웃 시프트 방지를 위한 플레이스홀더 (동일 높이·간격 유지)
 */
export function HeaderNavSkeleton() {
  return (
    <nav className="flex items-center gap-4" aria-hidden>
      <div className="h-9 w-[7rem] animate-pulse rounded-md bg-muted" />
      <div className="size-9 animate-pulse rounded-md bg-muted" />
      <div className="size-9 animate-pulse rounded-md bg-muted" />
    </nav>
  )
}
